export default [
  {
    "id": "mat-enem-0299",
    "numero": 1799,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "Em uma cidade, a cada inauguração de prédios, \na orientação da prefeitura, por meio de uma lei \nde incentivo à cultura, é a construção de uma \nobra de arte na entrada ou no hall desse prédio. \nEm contrapartida, a prefeitura oferece abatimen-\nto em impostos. No edifício das Acácias, o artis- \nta contratado resolveu fazer um quadro compos-\nto de 12 mosaicos, de dimensões de 12 cm por \n6 cm cada um, conforme a figura. \n \n \n \nA área da figura sombreada do quadro é de: \n \nA) 36 cm2. \nB) 72 cm2. \nC) 144 cm2. \nD) 288 cm2. \nE) 432 cm2.",
    "alternativas": {
      "A": "36 cm2.",
      "B": "72 cm2.",
      "C": "144 cm2.",
      "D": "288 cm2."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2011.2",
    "numeroOriginal": 299,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0300",
    "numero": 1800,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "Um curso preparatório oferece aulas de 8 disci-\nplinas distintas. Um aluno, ao se matricular, \nescolhe de 3 a 8 disciplinas para cursar. O pre-\nço P, em reais, da mensalidade é calculado pela \nfórmula, P(n) = 980 - 1680/n, onde n é o número \nde disciplinas escolhidas pelo aluno.  \n \nAlex deseja matricular seu filho Júlio e, consul-\ntando seu orçamento familiar mensal, avaliou \nque poderia pagar uma mensalidade de, no \nmáximo, R$ 720,00. O número máximo de dis-\nciplinas que Júlio poderá escolher ao se matri-\ncular nesse curso, sem estourar o orçamento \nfamiliar, é igual a: \n \nA) 3. \nB) 4. \nC) 6. \nD) 7. \nE) 8.",
    "alternativas": {
      "D": "7.",
      "E": "8.",
      "B": "4.",
      "C": "6."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2011.2",
    "numeroOriginal": 300,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0301",
    "numero": 1801,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "Um administrador de um campo de futebol de-\nseja recobri-lo com um tipo de grama que, em \ncondições normais, cresce de acordo com o \ngráfico a seguir. \n \n \nEle precisa ter o campo pronto no dia 11 de \njunho de 2012, e o comprimento mínimo da \ngrama nesse dia deve ser igual a 7 cm. Supon-\ndo-se que o crescimento da grama se dê em \ncondições normais, a grama deve ser plantada, \nno máximo, até o dia: \n \nA) 17 de maio de 2012. \nB) 21 de maio de 2012. \nC) 23 de maio de 2012. \nD) 8 de junho de 2012. \nE) 9 de junho de 2012.",
    "alternativas": {
      "E": "9 de junho de 2012.",
      "A": "17 de maio de 2012.",
      "B": "21 de maio de 2012.",
      "D": "8 de junho de 2012."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2011.2",
    "numeroOriginal": 301,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0302",
    "numero": 1802,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "As fábricas de pneus utilizam-se de modelos \nmatemáticos próprios em sua produção, para a \nadaptação dos vários tipos de pneus aos veícu-\nlos: de bicicletas a caminhões, tratores e aviões.  \n \nUm dos conceitos utilizados pela indústria é o \nde “índice de carga”, que está relacionado à \ncarga máxima que pode ser suportada por um \npneu. Uma empresa fabricante de pneus apre-\nsenta o seguinte quadro, relativo às cargas má-\nximas suportadas por pneus cujos índices vari-\nam de 70 a 80. Há um comportamento regular \nem alguns intervalos, como se observa entre os \níndices de 70 a 74. \n \n \n \nQual equação representa a dependência entre o \níndice de carga (I) e a carga máxima (C), em kg, \nno intervalo de 70 a 74? \n \nA) I = \nC\n10 – 100 \n \nB) I = \nC\n10 + 36,5 \n \nC) I = \nC\n10 – 328 \n \nD) I = 10C – 3280 \n \nE) I = 10C - 70",
    "alternativas": {
      "A": "I = C 10 – 100",
      "B": "I = C 10 + 36,5",
      "D": "I = 10C – 3280",
      "E": "I = 10C - 70"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2011.2",
    "numeroOriginal": 302,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0304",
    "numero": 1804,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "Um pesquisador analisava duas culturas dife-\nrentes com o objetivo de verificar como ocorria a \nevolução, ao longo do tempo, do crescimento do \nnúmero de bactérias presentes em cada uma \ndas culturas, sob certas condições. Esta evolu-\nção foi representada no gráfico a seguir: \n \n \n \nEm que intervalo de tempo o número de bacté-\nrias na colônia II foi maior do que o número de \nbactérias na colônia I? \n \nA) De 0 a 10 minutos. \nB) De 10 a 15 minutos. \nC) De 15 a 20 minutos. \nD) De 30 a 55 minutos. \nE) De 55 a 75 minutos.",
    "alternativas": {
      "C": "De 15 a 20 minutos.",
      "D": "De 30 a 55 minutos.",
      "A": "De 0 a 10 minutos.",
      "B": "De 10 a 15 minutos."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2011.2",
    "numeroOriginal": 304,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0305",
    "numero": 1805,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "O salário-mínimo ― menor salário que um tra-\nbalhador pode receber ― é estabelecido por lei \ne reavaliado todos os anos com base no custo \nde vida da população. A tabela apresenta uma \nsérie histórica do salário-mínimo no Brasil: \n \n \n \nQue número inteiro representa, o valor mais \naproximado do aumento sofrido pelo salário-\nmínimo, de 1994 a 2008, em pontos percentu-\nais? \n \nA) 14 \nB) 38 \nC) 67 \nD) 265 \nE) 493",
    "alternativas": {
      "C": "67",
      "D": "265",
      "E": "493",
      "B": "38"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2011.2",
    "numeroOriginal": 305,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0306",
    "numero": 1806,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "A torre de Hanói é um jogo que tem o objetivo \nde mover todos os discos de uma haste para \noutra, utilizando o menor número possível de \nmovimento, respeitando-se as regras. \n \n \n \nAs regras são: \n \n1 - um disco maior não pode ser colocado sobre \num disco menor; \n2 - pode-se mover um único disco por vez; \n3 - um disco deve estar sempre em uma das \ntrês hastes ou em movimento. \n \nUsando a torre de Hanói e baseando-se nas \nregras do jogo, podemos montar uma tabela \nentre o número de peças (X) e o número míni-\nmo de movimentos (Y): \n \n \n \nA relação entre (X) e (Y) é: \n \nA) Y = 2X – 1 \nB) Y = 2X – 1 \nC) Y = 2X \nD) Y = 2X – 1 \nE) Y = 2X – 4",
    "alternativas": {
      "C": "Y = 2X",
      "D": "Y = 2X – 1",
      "E": "Y = 2X – 4",
      "A": "Y = 2X – 1"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2011.2",
    "numeroOriginal": 306,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0307",
    "numero": 1807,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "O quadro indica a quantidade de pontos marca-\ndos, em quatro partidas, por cinco jogadores de \numa mesma equipe de basquete. \n \n \n \nComo todos os jogadores obtiveram a mesma \nmédia de pontos por partida, para definir quem, \nentre os cinco atletas, foi o de melhor rendimen-\nto, o técnico da equipe resolveu escolher aquele \nde maior regularidade. \n \nDessa forma, ele escolheu o jogador: \nA) A. \nB) B. \nC) C. \nD) D. \nE) E.",
    "alternativas": {
      "A": "A.",
      "B": "B.",
      "C": "C.",
      "E": "E."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2011.2",
    "numeroOriginal": 307,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0308",
    "numero": 1808,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "Fabiana Murer garante mais uma medalha de \nouro na Noruega. A atleta brasileira saltou 4,60 \nm na etapa da Diamond League e terminou em \nprimeiro lugar na disputa. Ela ainda é detentora \nda melhor marca do ano. Ao final da prova, a \nclassificação dos quatro melhores resultados foi: \n \n1º lugar: Fabiana Murer (BRA) – 4,60 m \n2º lugar: Aleksandra Kiryashiva (RUS) – 4,50 m \n3º lugar: Anna Rogowska (POL) – 4,40 m \n4º lugar: Monika Pyrek (POL) – 4,30 m \n \nA diferença entre as marcas da 1ª e da 4ª colo-\ncadas pode ser comparada com a altura de um \nanimal adulto. Que animal é esse? \n \nA) Gato. \nB) Leão. \nC) Pulga. \nD) Elefante. \nE) Gafanhoto.",
    "alternativas": {
      "E": "Gafanhoto.",
      "A": "Gato.",
      "B": "Leão.",
      "C": "Pulga."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2011.2",
    "numeroOriginal": 308,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0309",
    "numero": 1809,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "Numa sementeira, cinco canteiros quadrados \nserão preparados para plantar, em cada um, \ndois tipos de sementes: A e B. Os canteiros \nestão representados segundo as figuras: \n \n \n \nSuponha que cada canteiro tem 1 m² de área e \nque nas regiões sombreadas de cada canteiro \nserão plantadas as sementes do tipo A. Qual o \ntotal da área, em m², reservada para as semen-\ntes do tipo B? \n \nA) 1,25 \nB) 2 \nC) 2,5 \nD) 3 \nE) 5",
    "alternativas": {
      "B": "2",
      "C": "2,5",
      "D": "3",
      "A": "1,25"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2011.2",
    "numeroOriginal": 309,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0310",
    "numero": 1810,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "Toda a esfera visível ao longo do ano, nos he-\nmisférios celestes Norte e Sul, está dividida em \n88 partes, incluindo, cada uma delas, um núme-\nro variável de estrelas. A unidade de medida \nutilizada pelos astrônomos para calcular a área \nde uma constelação é o grau quadrado. Algu-\nmas constelações são imensas, como Erídano, \no rio celeste, localizada no hemisfério celeste \nSul e ocupa uma área de 1 138 graus quadra-\ndos. Em contraponto, a constelação Norma, \nlocalizada no mesmo hemisfério, não passa de \n165 graus quadrados. \n \nEm um mapa do hemisfério celestial feito em \numa escala de 1:1 000, as constelações Erída-\nno e Norma ocuparão, respectivamente, uma \nárea, em graus quadrados, de: \n \nA) 0,1138 e 0,0165. \nB) 0,1138 e 0,165. \nC) 1,138 e 0,165. \nD) 11 380 e 1 650. \nE) 1 138 000 e 165 000.",
    "alternativas": {
      "B": "0,1138 e 0,165.",
      "C": "1,138 e 0,165.",
      "D": "11 380 e 1 650.",
      "E": "1 138 000 e 165 000."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2011.2",
    "numeroOriginal": 310,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0311",
    "numero": 1811,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "Célia é uma confeiteira renomada na pequena \ncidade onde mora. Herdou de sua avó uma \nreceita de brigadeiro que faz o maior sucesso. \nOs ingredientes da receita enchem sempre uma \npanela, de forma cilíndrica, com 40 cm de altura \ne 30 cm de diâmetro. Para inovar e atrair mais \nclientes, em vez de vender os brigadeiros na \nforma de “bolinhas”, Célia tem feito brigadeiros \nem forma de cones. Para isso, utiliza forminhas \ncônicas de 5 cm de altura e raio da base de \n1,5cm. \n \nA cada receita produzida, a quantidade de co-\nnes de brigadeiro que Célia consegue obter é: \n \n \n \nA) 600 unidades. \nB) 800 unidades. \nC) 2 400 unidades. \nD) 3 200 unidades. \nE) 9 600 unidades.",
    "alternativas": {
      "C": "2 400 unidades.",
      "D": "3 200 unidades.",
      "E": "9 600 unidades.",
      "A": "600 unidades."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2011.2",
    "numeroOriginal": 311,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0312",
    "numero": 1812,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "O gráfico faz uma comparação entre os cresci-\nmentos das ações da Vale e da Ibovespa de \njaneiro a abril de 2010. De acordo com as in-\nformações do gráfico, o crescimento das ações \nda Vale e da Ibovespa no período de janeiro a \nabril de 2010 foram, respectivamente, de: \n \nA) 5,0% e 21,0%. \nB) 10,5% e 21,0%. \nC) 21,0% e 5,0%. \nD) 21,0% e 10,5%. \nE) 27,4% e 5,0%.",
    "alternativas": {
      "B": "10,5% e 21,0%.",
      "C": "21,0% e 5,0%.",
      "E": "27,4% e 5,0%.",
      "A": "5,0% e 21,0%."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2011.2",
    "numeroOriginal": 312,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0313",
    "numero": 1813,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "Um caminhão precisa recolher o lixo das ruas \nde um certo bairro. Por questões econômicas e \nambientais, a empresa IMJ, responsável pela \ncoleta, planeja as rotas de recolhimento, de \nmodo que o caminhão percorra a menor distân-\ncia possível, passando em cada rua exatamente \numa vez, entrando e saindo de cada ponto. \nQuando isso não é possível, busca-se repetir o \nmenor número possível de ruas na rota. Na \nfigura, temos um esquema no qual os pontos \nrepresentam esquinas, e as linhas representam \nas ruas. \n \n \nConsidere que cada rua mede 150 m de com-\nprimento e que a rota do caminhão comece e \ntermine no ponto A, passando por todas as ruas \ndo esquema. A empresa conseguiu encontrar a \nmelhor rota de recolhimento de lixo, na qual o \ncaminhão percorre uma distância igual a: \n \nA) 2 400 m. \nB) 2550 m. \nC) 2700 m. \nD) 2850 m. \nE) 3300 m.",
    "alternativas": {
      "C": "2700 m.",
      "E": "3300 m.",
      "A": "2 400 m.",
      "B": "2550 m."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2011.2",
    "numeroOriginal": 313,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0314",
    "numero": 1814,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "Na zona rural, a utilização de unidades de me-\ndida como o hectare é bastante comum. O hec-\ntare equivale à área de um quadrado de lado \nigual a 100 metros. Na figura, há a representa-\nção de um terreno por meio da área em desta-\nque. Nesta figura, cada quadrado que compõe \nesta malha representa uma área de 1 hectare. \n \n \n \nO terreno em destaque foi comercializado pelo \nvalor R$ 3600000,00. O valor do metro quadra-\ndo desse terreno foi de: \n \nA) R$ 30,00. \nB) R$ 300,00. \nC) R$ 360,00. \nD) R$ 3 600,00. \nE) R$ 300 000,00.",
    "alternativas": {
      "B": "R$ 300,00.",
      "C": "R$ 360,00.",
      "D": "R$ 3 600,00.",
      "A": "R$ 30,00."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2011.2",
    "numeroOriginal": 314,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0316",
    "numero": 1816,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "O esporte de alta competição da atualidade \nproduziu uma questão ainda sem resposta: Qual \né o limite do corpo humano? O maratonista ori-\nginal, o grego da lenda, morreu de fadiga por ter \ncorrido 42 quilômetros. O americano Dean Kar-\nnazes, cruzando sozinho as planícies da Cali-\nfórnia, conseguiu correr dez vezes mais em 75 \nhoras. Um professor de Educação Física, ao \ndiscutir com a turma o texto sobre a capacidade \ndo maratonista americano, desenhou na lousa \numa pista reta de 60 centímetros, que represen-\ntaria o percurso referido.  \n \nSe o percurso de Dean Karnazes fosse também \nem uma pista reta, qual seria a escala entre a \npista feita pelo professor e a percorrida pelo \natleta? \n \nA) 1:700 \nB) 1:7000 \nC) 1:70000 \nD) 1:700000 \nE) 1:7000000",
    "alternativas": {
      "C": "1:70000",
      "D": "1:700000",
      "E": "1:7000000",
      "A": "1:700"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2012.1",
    "numeroOriginal": 316,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0317",
    "numero": 1817,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "O losango representado na Figura 1 foi formado \npela união dos centros das quatro circunferên-\ncias tangentes, de raios de mesma medida. \n \nFigura 1 \n \nDobrando-se o raio de duas das circunferências \ncentradas em vértices opostos do losango e \nainda mantendo-se a configuração das tangên-\ncias, obtém-se uma situação conforme ilustrada \npela Figura 2. \n \n \nFigura 2 \n \nO perímetro do losango da Figura 2, quando \ncomparado ao perímetro do losango da Figura \n1, teve um aumento de: \n \nA) 300% \nB) 200% \nC) 150% \nD) 100% \nE) 50%",
    "alternativas": {
      "B": "200%",
      "D": "100%",
      "E": "50%",
      "A": "300%"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2012.1",
    "numeroOriginal": 317,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0318",
    "numero": 1818,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "José, Carlos e Paulo devem transportar em \nsuas bicicletas uma certa quantidade de laran-\njas. Decidiram dividir o trajeto a ser percorrido \nem duas partes, sendo que ao final da primeira \nparte eles redistribuiriam a quantidade de laran-\njas que cada um carregava dependendo do \ncansaço de cada um. Na primeira parte do traje-\nto José, Carlos e Paulo dividiram as laranjas na \nproporção 6 : 5 : 4, respectivamente. Na segun-\nda parte do trajeto José, Carlos e Paulo dividi-\nram as laranjas na proporção 4 : 4 : 2, respecti-\nvamente.  \n \nSabendo-se que um deles levou 50 laranjas a \nmais no segundo trajeto, qual a quantidade de \nlaranjas que José, Carlos e Paulo, nessa ordem, \ntransportaram na segunda parte do trajeto? \n \nA) 600, 550, 350 \nB) 300, 300, 150 \nC) 300, 250, 200 \nD) 200, 200, 100 \nE) 100, 100, 50",
    "alternativas": {
      "A": "600, 550, 350",
      "B": "300, 300, 150",
      "C": "300, 250, 200",
      "E": "100, 100, 50"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2012.1",
    "numeroOriginal": 318,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0319",
    "numero": 1819,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "Em um blog de variedades, músicas, mantras e \ninformações diversas, foram postados “Contos \nde Halloween”. Após a leitura, os visitantes po-\nderiam opinar, assinalando suas reações em: \n“Divertido”, “Assustador” ou “Chato”. Ao final de \numa semana, o blog registrou que 500 visitantes \ndistintos acessaram esta postagem. O gráfico a \nseguir apresenta o resultado da enquete. \n \n \n \nO administrador do blog irá sortear um livro \nentre os visitantes que opinaram na postagem \n“Contos de Halloween”.  \n \nSabendo que nenhum visitante votou mais de \numa vez, a probabilidade de uma pessoa esco-\nlhida ao acaso entre as que opinaram ter assi-\nnalado que o conto “Contos de Halloween” é \n“Chato” é mais aproximada por: \n \nA) 0,09. \nB) 0,12. \nC) 0,14. \nD) 0,15. \nE) 0,18.",
    "alternativas": {
      "D": "0,15.",
      "A": "0,09.",
      "B": "0,12.",
      "C": "0,14."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2012.1",
    "numeroOriginal": 319,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0320",
    "numero": 1820,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "Arthur deseja comprar um terreno de Cléber, \nque lhe oferece as seguintes possibilidades de \npagamento: \n \n• Opção 1: Pagar à vista, por R$ 55 000,00; \n \n• Opção 2: Pagar a prazo, dando uma entra-\nda de R$ 30 000,00, e mais uma prestação \nde R$ 26 000,00 para dali a 6 meses. \n \n• Opção 3: Pagar a prazo, dando uma entra-\nda de R$ 20 000,00, mais uma prestação de \nR$ 20 000,00, para dali a 6 meses e outra de \nR$ 18 000,00 para dali a 12 meses da data \nda compra. \n \n• Opção 4: Pagar a prazo dando uma entra-\nda de R$ 15 000,00 e o restante em 1 ano da \ndata da compra, pagando R$ 39 000,00. \n \n• Opção 5: pagar a prazo, dali a um ano, o \nvalor de R$ 60 000,00. \nArthur tem o dinheiro para pagar à vista, mas \navalia se não seria melhor aplicar o dinheiro do \nvalor à vista (ou até um valor menor) em um \ninvestimento, com rentabilidade de 10% ao se-\nmestre, resgatando os valores à medida que as \nprestações da opção escolhida fossem vencen-\ndo. \n \nApós avaliar a situação do ponto de vista finan-\nceiro e das condições apresentadas, Arthur \nconcluiu que era mais vantajoso financeiramen-\nte escolher a opção: \n \nA) 1. \nB) 2. \nC) 3. \nD) 4. \nE) 5.",
    "alternativas": {
      "C": "3.",
      "D": "4.",
      "E": "5.",
      "B": "2."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2012.1",
    "numeroOriginal": 320,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0321",
    "numero": 1821,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "Um forro retangular de tecido traz em sua eti-\nqueta a informação de que encolherá após a \nprimeira lavagem mantendo, entretanto, seu \nformato. A figura a seguir mostra as medidas \noriginais do forro e o tamanho do encolhimento \n(x) no comprimento e (y) na largura. A expres-\nsão algébrica que representa a área do forro \napós ser lavado é (5 – x) (3 – y). \n \n \n \nNestas condições, a área perdida do forro, após \na primeira lavagem, será expressa por: \n \nA) 2xy \nB) 15 − 3x \nC) 15 − 5y \nD) −5y − 3x \nE) 5y + 3x − xy",
    "alternativas": {
      "C": "15 − 5y",
      "D": "−5y − 3x",
      "E": "5y + 3x − xy",
      "A": "2xy"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2012.1",
    "numeroOriginal": 321,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0322",
    "numero": 1822,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "A capacidade mínima, em BTU/h, de um apare-\nlho de ar-condicionado, para ambientes sem \nexposição ao sol, pode ser determinada da se-\nguinte forma: \n \n• 600 BTU/h por m2, considerando-se até \nduas pessoas no ambiente; \n• para cada pessoa adicional nesse ambi-\nente, acrescentar 600 BTU/h; \n• acrescentar mais 600 BTU/h para cada \nequipamento eletroeletrônico em funciona-\nmento no ambiente. \nSerá instalado um aparelho de ar-condicionado \nem uma sala, sem exposição ao sol, de dimen-\nsões 4 m x 5 m, em que permaneçam quatro \npessoas e possua um aparelho de televisão em \nfuncionamento.  \n \nA capacidade mínima, em BTU/h, desse apare-\nlho de ar condicionado deve ser? \n \nA) 12 000. \nB) 12 600. \nC) 13 200. \nD) 13 800. \nE) 15 000.",
    "alternativas": {
      "E": "15 000.",
      "A": "12 000.",
      "B": "12 600.",
      "D": "13 800."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2012.1",
    "numeroOriginal": 322,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0323",
    "numero": 1823,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "A resistência mecânica S de uma viga de ma-\ndeira, em forma de um paralelepípedo retângu-\nlo, é diretamente proporcional à sua largura (b) \ne ao quadrado de sua altura (d) e inversamente \nproporcional ao quadrado da distância entre os \nsuportes da viga, que coincide com o seu com-\nprimento (x), conforme ilustra a figura. A cons-\ntante de proporcionalidade k é chamada de \nresistência da viga. \n \n \n \nA expressão que traduz a resistência S dessa \nviga de madeira é: \n \nA) S = \nk.b.d2\nx2  \n \nB) S = \nk.b.d\nx2  \n \nC) S = \nk.b.d2\nx  \n \nD) S = \nk.b2.d\nx  \n \nE) S = \nk.b.2d\n2x",
    "alternativas": {
      "C": "S = k.b.d2 x",
      "E": "S = k.b.2d 2x",
      "A": "S = k.b.d2 x2",
      "B": "S = k.b.d x2"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2012.1",
    "numeroOriginal": 323,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0324",
    "numero": 1824,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "O diretor de uma escola convidou os 280 alunos \nde terceiro ano a participarem de uma brincadei-\nra. Suponha que existem 5 objetos e 6 persona-\ngens numa casa de 9 cômodos; um dos perso-\nnagens esconde um dos objetos em um dos \ncômodos da casa. O objetivo da brincadeira é \nadivinhar qual objeto foi escondido por qual \npersonagem e em qual cômodo da casa o obje-\nto foi escondido. \n \nTodos os alunos decidiram participar. A cada \nvez um aluno é sorteado e dá a sua resposta. \nAs respostas devem ser sempre distintas das \nanteriores, e um mesmo aluno não pode ser \nsorteado mais de uma vez. Se a resposta do \naluno estiver correta, ele é declarado vencedor \ne a brincadeira é encerrada. \n \nO diretor sabe que algum aluno acertará a res-\nposta porque há: \n \nA) 10 alunos a mais do que possíveis respostas \ndistintas. \nB) 20 alunos a mais do que possíveis respostas \ndistintas. \nC) 119 alunos a mais do que possíveis respos-\ntas distintas. \nD) 260 alunos a mais do que possíveis respos-\ntas distintas. \nE) 270 alunos a mais do que possíveis respos-\ntas distintas.",
    "alternativas": {
      "D": "260 alunos a mais do que possíveis respos- tas distintas.",
      "A": "10 alunos a mais do que possíveis respostas distintas.",
      "B": "20 alunos a mais do que possíveis respostas distintas.",
      "C": "119 alunos a mais do que possíveis respos- tas distintas."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2012.1",
    "numeroOriginal": 324,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0325",
    "numero": 1825,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "Um biólogo mediu a altura de cinco árvores \ndistintas e representou-as em uma mesma ma-\nlha quadriculada, utilizando escalas diferentes, \nconforme indicações na figura a seguir. \n \n \n \nQual é a árvore que apresenta a maior altura \nreal? \n \nA) I \nB) II \nC) III \nD) IV \nE) V",
    "alternativas": {
      "D": "IV",
      "E": "V",
      "B": "II",
      "C": "III"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2012.1",
    "numeroOriginal": 325,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0326",
    "numero": 1826,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "Em um jogo há duas urnas com 10 bolas de \nmesmo tamanho em cada urna. A tabela a se-\nguir indica as quantidades de bolas de cada cor \nem cada urna. \n \n \n \nUma jogada consiste em: \n \n1º) o jogador apresenta um palpite sobre a cor da \nbola que será retirada por ele da urna 2; \n2º) ele retira, aleatoriamente, uma bola da urna 1 e \na coloca na urna 2, misturando-a com as que lá \nestão; \n3º) em seguida ele retira, também aleatoriamente, \numa bola da urna 2; \n4º) se a cor da última bola retirada for a mesma do \npalpite inicial, ele ganha o jogo. \n \nQual cor deve ser escolhida pelo jogador para \nque ele tenha a maior probabilidade de ganhar? \n \nA) Azul. \nB) Amarela. \nC) Branca. \nD) Verde. \nE) Vermelha.",
    "alternativas": {
      "D": "Verde.",
      "E": "Vermelha.",
      "A": "Azul.",
      "C": "Branca."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2012.1",
    "numeroOriginal": 326,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0327",
    "numero": 1827,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "Os hidrômetros são marcadores de consumo de \nágua em residências e estabelecimentos co-\nmerciais. Existem vários modelos de mostrado-\nres de hidrômetros, sendo que alguns deles \npossuem uma combinação de um mostrador e \ndois relógios de ponteiro. O número formado \npelos quatro primeiros algarismos do mostrador \nfornece o consumo em m3, e os dois últimos \nalgarismos representam, respectivamente, as \ncentenas e dezenas de litros de água consumi-\ndos. Um dos relógios de ponteiros indica a \nquantidade em litros, e o outro em décimos de \nlitros, conforme ilustrados na figura a seguir. \nConsiderando as informações indicadas na figu-\nra, o consumo total de água registrado nesse \nhidrômetro, em litros, é igual a: \n \nA) 3 534,85. \nB) 3 544,20. \nC) 3 534 850,00 \nD) 3 534 859,35. \nE) 3 534 850,39.",
    "alternativas": {
      "A": "3 534,85.",
      "B": "3 544,20.",
      "D": "3 534 859,35.",
      "E": "3 534 850,39."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2012.1",
    "numeroOriginal": 327,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0328",
    "numero": 1828,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "O dono de uma farmácia resolveu colocar à \nvista do público o gráfico mostrado a seguir, que \napresenta a evolução do total de vendas (em \nReais) de certo medicamento ao longo do ano \nde 2011. \n \n \n \nDe acordo com o gráfico, os meses em que \nocorreram, respectivamente, a maior e a menor \nvenda absolutas em 2011 foram: \n \nA) março e abril. \nB) março e agosto. \nC) agosto e setembro. \nD) junho e setembro. \nE) junho e agosto.",
    "alternativas": {
      "A": "março e abril.",
      "B": "março e agosto.",
      "C": "agosto e setembro.",
      "E": "junho e agosto."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2012.1",
    "numeroOriginal": 328,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0329",
    "numero": 1829,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "Maria quer inovar em sua loja de embalagens e \ndecidiu vender caixas com diferentes formatos. \nNas imagens apresentadas estão as planifica-\nções dessas caixas. \n \n \n \nQuais serão os sólidos geométricos que Maria \nobterá a partir dessas planificações? \n \nA) Cilindro, prisma de base pentagonal e pirâ-\nmide. \nB) Cone, prisma de base pentagonal e pirâmide. \nC) Cone, tronco de pirâmide e pirâmide. \nD) Cilindro, tronco de pirâmide e prisma. \nE) Cilindro, prisma e tronco de cone.",
    "alternativas": {
      "A": "Cilindro, prisma de base pentagonal e pirâ- mide.",
      "B": "Cone, prisma de base pentagonal e pirâmide.",
      "C": "Cone, tronco de pirâmide e pirâmide.",
      "D": "Cilindro, tronco de pirâmide e prisma."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2012.1",
    "numeroOriginal": 329,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0330",
    "numero": 1830,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "Jogar baralho é uma atividade que estimula o \nraciocínio. Um jogo tradicional é a Paciência, \nque utiliza 52 cartas. Inicialmente são formadas \nsete colunas com as cartas. A primeira coluna \ntem uma carta, a segunda tem duas cartas, a \nterceira tem três cartas, a quarta tem quatro \ncartas, e assim sucessivamente até a sétima \ncoluna, a qual tem sete cartas, e o que sobra \nforma o monte, que são as cartas não utilizadas \nnas colunas. \n \nA quantidade de cartas que forma o monte é: \n \nA) 21. \nB) 24. \nC) 26. \nD) 28. \nE) 31.",
    "alternativas": {
      "C": "26.",
      "D": "28.",
      "E": "31.",
      "B": "24."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2012.1",
    "numeroOriginal": 330,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0331",
    "numero": 1831,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "O gráfico mostra a variação da extensão média \nde gelo marítimo, em milhões de quilômetros \nquadrados, comparando dados dos anos 1995, \n1998, 2000, 2005 e 2007. Os dados correspon-\ndem aos meses de junho a setembro. O Ártico \ncomeça a recobrar o gelo quando termina o \nverão, em meados de setembro.  \n \nO gelo do mar atua como o sistema de resfria-\nmento da Terra, refletindo quase toda a luz solar \nde volta ao espaço. Águas de oceanos escuros, \npor sua vez, absorvem a luz solar e reforçam o \naquecimento do Ártico, ocasionando derretimen-\nto crescente do gelo. \n \n \n \nCom base no gráfico e nas informações do tex-\nto, é possível inferir que houve maior aqueci-\nmento global em: \n \nA) 1995. \nB) 1998. \nC) 2000. \nD) 2005. \nE) 2007.",
    "alternativas": {
      "E": "2007.",
      "A": "1995.",
      "C": "2000.",
      "D": "2005."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2012.1",
    "numeroOriginal": 331,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0332",
    "numero": 1832,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "Em exposições de artes plásticas, é usual que \nestátuas sejam expostas sobre plataformas \ngiratórias. Uma medida de segurança é que a \nbase da escultura esteja integralmente apoiada \nsobre a plataforma. Para que se providencie o \nequipamento adequado, no caso de uma base \nquadrada que será fixada sobre uma plataforma \ncircular, o auxiliar técnico do evento deve esti-\nmar a medida R do raio adequado para a plata-\nforma em termos da medida L do lado da base \nda estátua.  \n \nQual relação entre R e L o auxiliar técnico deve-\nrá apresentar de modo que a exigência de segu-\nrança seja cumprida? \n \nA) R ≥ L / √2 \nB) R ≥ 2L / 𝜋 \nC) R ≥ L / √𝜋  \nD) R ≥ L / 2 \nE) R ≥ L / (2√2)",
    "alternativas": {
      "E": "R ≥ L / (2√2)",
      "A": "R ≥ L / √2",
      "B": "R ≥ 2L / 𝜋",
      "D": "R ≥ L / 2"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2012.1",
    "numeroOriginal": 332,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0334",
    "numero": 1834,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "Num projeto da parte elétrica de um edifício \nresidencial a ser construído, consta que as to-\nmadas deverão ser colocadas a 0,20 m acima \ndo piso, enquanto os interruptores de luz deve-\nrão ser colocados a 1,47 m acima do piso. Um \ncadeirante, potencial comprador de um aparta-\nmento desse edifício, ao ver tais medidas, alerta \npara o fato de que elas não contemplarão suas \nnecessidades. Os referenciais de alturas (em \nmetros) para atividades que não exigem o uso \nde força são mostrados na figura seguinte. \n \n \n \nUma proposta substitutiva, relativa às alturas de \ntomadas e interruptores, respectivamente, que \natenderá àquele potencial comprador é: \n \nA) 0,20 m e 1,45 m. \nB) 0,20 m e 1,40 m. \nC) 0,25 m e 1,35 m. \nD) 0,25 m e 1,30 m. \nE) 0,45 m e 1,20 m.",
    "alternativas": {
      "D": "0,25 m e 1,30 m.",
      "E": "0,45 m e 1,20 m.",
      "B": "0,20 m e 1,40 m.",
      "C": "0,25 m e 1,35 m."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2012.1",
    "numeroOriginal": 334,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0335",
    "numero": 1835,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "Uma pesquisa realizada por estudantes da Fa-\nculdade de Estatística mostra, em horas por dia, \ncomo os jovens entre 12 e 18 anos gastam seu \ntempo, tanto durante a semana (de segunda-\nfeira a sexta-feira), como no fim de semana \n(sábado e domingo). A seguinte tabela ilustra os \nresultados da pesquisa. \n \n \n \nDe acordo com esta pesquisa, quantas horas de \nseu tempo gasta um jovem entre 12 e 18 anos, \nna semana inteira (de segunda-feira a domin-\ngo), nas atividades escolares? \n \nA) 20 \nB) 21 \nC) 24 \nD) 25 \nE) 27",
    "alternativas": {
      "E": "27",
      "B": "21",
      "C": "24",
      "D": "25"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2012.1",
    "numeroOriginal": 335,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0337",
    "numero": 1837,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "Um maquinista de trem ganha R$ 100,00 por \nviagem e só pode viajar a cada 4 dias. Ele ga-\nnha somente se fizer a viagem e sabe que esta-\nrá de férias de 1º a 10 de junho, quando não \npoderá viajar. Sua primeira viagem ocorreu no \ndia primeiro de janeiro. Considere que o ano \ntem 365 dias. Se o maquinista quiser ganhar o \nmáximo possível, e quantas viagens precisará \nfazer? \n \nA) 37 \nB) 51 \nC) 88 \nD) 89 \nE) 91",
    "alternativas": {
      "C": "88",
      "E": "91",
      "A": "37",
      "B": "51"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2012.1",
    "numeroOriginal": 337,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0338",
    "numero": 1838,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "Alguns objetos, durante a sua fabricação, ne-\ncessitam passar por um processo de resfria-\nmento. Para que isso ocorra, uma fábrica utiliza \num tanque de resfriamento, como mostrado na \nfigura. \n \n \nO que aconteceria com o nível da água se colo-\ncássemos no tanque um objeto cujo volume \nfosse de 2400 cm3? \n \nA) O nível subiria 0,2 cm, fazendo a água ficar \ncom 20,2 cm de altura. \nB) O nível subiria 1 cm, fazendo a água ficar \ncom 21 cm de altura. \nC) O nível subiria 2 cm, fazendo a água ficar \ncom 22 cm de altura. \nD) O nível subiria 8 cm, fazendo a água trans-\nbordar. \nE) O nível subiria 20 cm, fazendo a água trans-\nbordar.",
    "alternativas": {
      "E": "O nível subiria 20 cm, fazendo a água trans- bordar.",
      "A": "O nível subiria 0,2 cm, fazendo a água ficar com 20,2 cm de altura.",
      "B": "O nível subiria 1 cm, fazendo a água ficar com 21 cm de altura.",
      "C": "O nível subiria 2 cm, fazendo a água ficar com 22 cm de altura."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2012.1",
    "numeroOriginal": 338,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0339",
    "numero": 1839,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "Jorge quer instalar aquecedores no seu salão \nde beleza para melhorar o conforto dos seus \nclientes no inverno. Ele estuda a compra de \nunidades de dois tipos de aquecedores: modelo \nA, que consome 600 g/h (gramas por hora) de \ngás propano e cobre 35 m2 de área, ou modelo \nB, que consome 750 g/h de gás propano e co-\nbre 45 m2 de área. O fabricante indica que o \naquecedor deve ser instalado em um ambiente \ncom área menor do que a da sua cobertura. \nJorge vai instalar uma unidade por ambiente e \nquer gastar o mínimo possível com gás. A área \ndo salão que deve ser climatizada encontra-se \nna planta seguinte (ambientes representados \npor três retângulos e um trapézio). \n \n \nAvaliando-se todas as informações, serão ne-\ncessários: \n \nA) quatro unidades do tipo A e nenhuma unida-\nde do tipo B. \nB) três unidades do tipo A e uma unidade do \ntipo B. \nC) duas unidades do tipo A e duas unidades do \ntipo B. \nD) uma unidade do tipo A e três unidades do \ntipo B. \nE) nenhuma unidade do tipo A e quatro unida-\ndes do tipo B.",
    "alternativas": {
      "A": "quatro unidades do tipo A e nenhuma unida- de do tipo B.",
      "B": "três unidades do tipo A e uma unidade do tipo B.",
      "C": "duas unidades do tipo A e duas unidades do tipo B.",
      "D": "uma unidade do tipo A e três unidades do tipo B."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2012.1",
    "numeroOriginal": 339,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0340",
    "numero": 1840,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "Para decorar a fachada de um edifício, um ar-\nquiteto projetou a colocação de vitrais compos-\ntos de quadrados de lado medindo 1 m, confor-\nme a figura a seguir. \n \n \n \nNesta figura, os pontos A, B, C e D são pontos \nmédios dos lados do quadrado e os segmentos \nAP e QC medem 1/4 da medida do lado do \nquadrado. Para confeccionar um vitral, são usa-\ndos dois tipos de materiais: um para a parte \nsombreada da figura, que custa R$ 30,00 o m2, \ne outro para a parte mais clara (regiões ABPDA \ne BCDQB), que custa R$ 50,00 o m2. \n \nDe acordo com esses dados, qual é o custo dos \nmateriais usados na fabricação de um vitral? \n \nA) R$ 22,50 \nB) R$ 35,00 \nC) R$ 40,00 \nD) R$ 42,50 \nE) R$ 45,00",
    "alternativas": {
      "E": "R$ 45,00",
      "B": "R$ 35,00",
      "C": "R$ 40,00",
      "D": "R$ 42,50"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2012.1",
    "numeroOriginal": 340,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0341",
    "numero": 1841,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "João decidiu contratar os serviços de uma em-\npresa por telefone através do SAC (Serviço de \nAtendimento ao Consumidor). O atendente ditou \npara João o número de protocolo de atendimen-\nto da ligação e pediu que ele anotasse. Entre-\ntanto, João não entendeu um dos algarismos \nditados pelo atendente e anotou o número \n1 3 _ 9 8 2 0 7, sendo que o espaço vazio é o \ndo algarismo que João não entendeu. \n \nDe acordo com essas informações, a posição \nocupada pelo algarismo que falta no número de \nprotocolo é a de: \n \nA) centena. \nB) dezena de milhar. \nC) centena de milhar. \nD) milhão. \nE) centena de milhão.",
    "alternativas": {
      "E": "centena de milhão.",
      "A": "centena.",
      "C": "centena de milhar.",
      "D": "milhão."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2012.1",
    "numeroOriginal": 341,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0342",
    "numero": 1842,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "O gráfico fornece os valores das ações da em-\npresa XPN, no período das 10 às 17 horas, num \ndia em que elas oscilaram acentuadamente em \ncurtos intervalos de tempo. \n \n \n \nNeste dia, cinco investidores compraram e ven-\nderam o mesmo volume de ações, porém em \nhorários diferentes, de acordo com a seguinte \ntabela. \n \n \n \nCom relação ao capital adquirido na compra e \nvenda das ações, qual investidor fez o melhor \nnegócio? \n \nA) 1 \nB) 2 \nC) 3 \nD) 4 \nE) 5",
    "alternativas": {
      "B": "2",
      "D": "4",
      "E": "5",
      "A": "1"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2012.1",
    "numeroOriginal": 342,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  }
];